'use strict'

import SpeedRoute from './speed-route.js';
import RouteMarker from '../markers/route-marker.js';


export default class AlarmRoute extends SpeedRoute {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        super(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo);
    }

    _makeMultiOptionsObject() {
        let multiopts = {
            optionIdxFn: (latLng) => {
                return latLng[2] - 1;
            },
            options: [
                { color: 'red' },
                { color: 'orange' },
                { color: 'grey' },
                { color: 'blue' },
                { color: 'green' }
            ]
        };
        return multiopts;
    }

    _createRouteMarker(point) {
        let statusColor = this.alarmColors[point.st - 1];
        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, statusColor);
    }

    _fillCoordsArray(point) {
        this.coordsArray.push([point.lat, point.lon, point.st]);
    }

    reduceIndex(index) {
        return index;
    }
}
